<template>
        <div class="head">
            <div class="background">
                <div class="headTop">核心团队介绍</div>
                <div class="headContent">我们是一支专业的团队，团队成员都拥有多年的互联网专业技术背景，实力过硬；我们是一支年轻的团队，年轻、朝气、充满创新与拼搏精神的；我们是一支有梦想的团队。我们来自五湖四海，走到一起，是因为一个共同的梦想：做一家最专注的互联网公司，专注为市场带来价值。</div>
            </div>
            <div class="move">
                <div>
                    <div class="content_top">平台能力地图</div>
                     <div class="content_text">科技赋予增长，我们共创未来</div>
                </div>
                <div class="carcusel_inner">
                    <div class="carcusel">
                        <el-carousel :interval="6000" type="card" height="340px" arrow="always">
                            <el-carousel-item v-for="item in hove.capability" :key="item">
                                <div style="padding:50px 40px 50px 50px">
                                    <div class="capability_title">{{item.title}}</div>
                                    <div class="capability_content" v-html="item.content">
                                        <!-- {{item.content}} -->
                                    </div>
                                    <el-image class="capability_img"  :src="item.img"></el-image>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
export default {
    data(){
        return{
            hove:{
             capability:[
                 {title:"管理层",content:`复合型人才架构，管理+技术精英强强组合，曾经是腾讯、阿里、华为等优秀骨干。`,img:require("./../assets/capability1.png")},
                 {title:"技术部门",content:"核心成员均从事多年互联网行业，各行业软件特点需求实践经验丰富。具有强大的软件研发能力和丰富的开发经验。",img:require("./../assets/capability1.png")},
                 {title:"运营部门",content:"团队由一支由运营骨干组成的高效率团队，懂内容，又策略思维，能策划，有资源。",img:require("./../assets/capability1.png")},
                 {title:"市场部门",content:"成员敢闯敢拼，融入客户，深挖市场需求，发现市场机遇和黑洞。",img:require("./../assets/capability1.png")},
                 {title:"银行事务部",content:"以专业事务对接能力，为公司链接银行合作，为产品寻找权威的资金护航者。",img:require("./../assets/capability1.png")},
                 {title:"政府事务部",content:"与政府保持密切联络，积极了解最新政策动态，以政策为导向为公司发展提供方向。",img:require("./../assets/capability1.png")},
                 {title:"商务BD",content:"有着灵活的应变能力，随时注意市场动态，分析市场信息，把握一线客户需求。",img:require("./../assets/capability1.png")},
                 {title:"产品部门",content:"资深产品开发经验，深刻理解行业的特征及行业用户的痛点，有效转化为高品质的产品设计，解决方案。",img:require("./../assets/capability1.png")}
             ]
          },
        }
    }
}
</script>

<style scoped>
  @import "./../style/index.scss";
  .background{
      background: url("./../assets/group.png");
      background-size: 100% 100%;
      height: 496px;
  
  }
  .headTop{
      font-size: 40px;
      font-family: "ku";
      color:#496DFA;
      text-align: center;
      padding: 30px 0px 30px 0px;
  }
  .headContent{
      color: #A6AABE;
      font-size: 16px;
      width: 40%;
      line-height: 30px;
      margin: 0 auto;
      position: relative;
      left: 30px;
  }
  .move{
      position: relative;
      top: -70px;
  }
</style>


// WEBPACK FOOTER //
// src/components/group.vue